import axios from "axios";
import { useNavigate } from "react-router-dom";

import { BackIcon, HomeIcon, LogoutIcon } from "../../assets/icons";
import { API_URL } from "../../constants";

import './styles.scss';

type HeaderProp = {
  home?: boolean,
  goBack?: boolean,
  logOut?: boolean,
}

export const Header = ({
  home,
  goBack,
  logOut,
}: HeaderProp) => {
  const navigate = useNavigate();

  const handleHome = () => {
    navigate('/');
  };
  const handleBack = () => {
    navigate(-1);
  };
  const handleLogout = () => {
    axios.get(`${API_URL}/logout`, {
      withCredentials: true,
    })
      .then(response => {
        console.log('User is logged out');
        localStorage?.removeItem('userId');
        navigate('/');
      })
      .catch(err => {
        console.log(err.response?.data?.message || err.message);
      });
    navigate('/');
    // localStorage.removeItem('userId');
  };

  return (
    <header className="Header">
      <div className="Wrapper">
        {home &&
          <button className="Button" onClick={handleHome}>
            <HomeIcon className="HomeIcon"/>
          </button>
        }
        {goBack &&
            <button className="Button" onClick={handleBack}>
                <BackIcon className="BackIcon"/>
            </button>
        }
        {logOut &&
          <button className="Button" onClick={handleLogout}>
            <LogoutIcon className="LogoutIcon"/>
          </button>
        }
      </div>
    </header>
  );
};
